'use client';

import dynamic from 'next/dynamic';

// Keeps the analytics bridge out of every page's initial client graph. It
// renders no UI and only publishes onto Shopify's analytics bus (rendered
// server-side by ShopifyScripts), which buffers events until consent resolves,
// so load it client-side after hydration in its own chunk. Do not idle-delay
// it: Shopify session counts depend on the first page_viewed event.
const ShopifyAnalytics = dynamic(
	() => import('./shopify-analytics').then((m) => m.ShopifyAnalytics),
	{ ssr: false },
);

export function ShopifyAnalyticsLazy() {
	return <ShopifyAnalytics />;
}
